import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf'; 
import { Warehouse } from '../warehouse';
import { WarehouseService } from '../warehouse.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import html2canvas from 'html2canvas';

declare var jsPDF: any;

@Component({
  selector: 'app-warehouse-details',
  templateUrl: './warehouse-details.component.html',
  styleUrls: ['./warehouse-details.component.css']
})
export class WarehouseDetailsComponent implements OnInit {

  warehouse = new Warehouse();

  constructor(
    private warehouseService: WarehouseService,
		private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.GetWarehouseDetails();
  }

  GetWarehouseDetails() {
    const warehouseid = +this.route.snapshot.paramMap.get('warehouseid');
    this.warehouseService.GetWarehouseDetails(warehouseid)
      .subscribe(warehouse =>
       { 
         this.warehouse = warehouse[0]
       });
  }

 goBack(): void {
   this.location.back();
 }

}
